module.exports = __webpack_public_path__ + "static/media/AegisWebsiteArchitect.951bf53c.JPG";